/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/**
 * @author Granite Bagas
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

import ModalTopRounded from '@components/modal/ModalTopRounded';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import ModalUpload from '@components/modal/ModalUpload';

import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import importTemplate from '@/assets/csv/template-import-add-product-listing';

const propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  handleAdd: PropTypes.func,
  handleAddImport: PropTypes.func,
};

const ModalAddProductListing = (props) => {
  const dispatch = useDispatch();

  const showImportModalAddProductListing = useSelector(
    (state) => state.modal.showImportModalAddProductListing,
  );

  const handleImport = async (url) => {
    await props.handleAddImport(url);
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleAddManually = () => {
    props.handleAdd();
  };

  const handleShowCsvOptions = () => {
    handleClose();
    dispatch(
      showPopup({
        name: 'showImportModalAddProductListing',
        value: true,
      }),
    );
  };

  return (
    <View>
      <ModalTopRounded
        title="Add Product List"
        visible={props.show}
        maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
        onClose={handleClose}>
        <View style={styles.userCreate}>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={handleAddManually}>
            <Image
              style={{ width: 43, height: 43 }}
              width={43}
              height={43}
              source={require('@assets/img/icons/add-manually.png')}
            />
            <SociollaText style={styles.itemText}>Add Manually</SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={handleShowCsvOptions}>
            <Image
              style={{ width: 35, height: 43 }}
              width={35}
              height={43}
              source={require('@assets/img/icons/import-csv.svg')}
            />
            <SociollaText style={styles.itemText}>Import CSV</SociollaText>
          </TouchableOpacity>
        </View>
      </ModalTopRounded>

      {showImportModalAddProductListing ? (
        <ModalUpload
          show={showImportModalAddProductListing}
          onClose={() =>
            dispatch(
              showPopup({
                name: 'showImportModalAddProductListing',
                value: false,
              }),
            )
          }
          templateUrl={importTemplate}
          onUpload={handleImport}
          autoUploadS3={true}
          name={'import_add_product_listing'}
          validHeader={['sku', 'is_active']}
        />
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  userCreate: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    justifyContent: 'center',
    flexDirection: 'row',
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
  },
  itemText: {
    fontSize: 14,
    marginTop: 15,
  },
});

ModalAddProductListing.propTypes = propTypes;

export default ModalAddProductListing;
